import type { CountryCode } from "../domain/register-wizard";

export interface GccCountry {
  code: CountryCode;
  label: string;
  /** Odoo res.country ID. Used when submitting `CreatePartnerDto.countryId`. */
  odooId: number;
  /** Example format shown as placeholder/helper. */
  crPlaceholder: string;
  taxPlaceholder: string;
}

// Odoo IDs follow the standard `res.country` demo data in v16/17.
// Verify against the target instance before shipping.
export const GCC_COUNTRIES: GccCountry[] = [
  {
    code: "QA",
    label: "Qatar",
    odooId: 178,
    crPlaceholder: "e.g. CR-123456",
    taxPlaceholder: "e.g. 1234567890",
  },
  {
    code: "SA",
    label: "Saudi Arabia",
    odooId: 190,
    crPlaceholder: "e.g. 1010123456",
    taxPlaceholder: "e.g. 300123456700003",
  },
  {
    code: "KW",
    label: "Kuwait",
    odooId: 117,
    crPlaceholder: "e.g. 123456",
    taxPlaceholder: "e.g. 1234567890",
  },
  {
    code: "BH",
    label: "Bahrain",
    odooId: 18,
    crPlaceholder: "e.g. 12345-1",
    taxPlaceholder: "e.g. 200000000000002",
  },
];

export function getGccCountry(code: CountryCode | "" | undefined) {
  if (!code) return undefined;
  return GCC_COUNTRIES.find((c) => c.code === code);
}
